<template>
    <div class="h-[95%]">
        <ai-tree-list-edit-wrapper
            ref="treeListRef"
            :hasnt-route="true"
            :preselectedRows="preselectedRows"
            :args="args"
            :meta="meta"
        />
    </div>

    <div class="text-right">
        <dx-button class="w-[50%]" text="Выбрать" @click="selectRows" />
    </div>
</template>

<script setup>
import AiTreeListEditWrapper from '@/components/wrappers/ai-tree-list-edit-wrapper.vue';
import { DxButton } from 'devextreme-vue';
import { ref } from 'vue';

const props = defineProps({
    cellInfo: {
        type: Object,
        default: () => {},
    },
    currentValue: {
        type: String,
        default: '',
    },
    rowClickCallBack: {
        type: Function,
        default: () => {},
    },
    args: {
        type: Object,
        default: () => {},
    },
    meta: {
        type: Object,
        default: () => {},
    },
});

const treeListRef = ref();
const preselectedRows =
    props?.cellInfo.value && props.cellInfo.value[0] !== null ? Object.values(props.cellInfo.value) : [];

const selectRows = () => {
    const { keyExpr, selectedRowKeys } = treeListRef.value.ref.treeListInstance.option();
    const treeListDataSource = treeListRef.value.ref.treeListInstance.option().dataSource;
    const row = {
        [keyExpr]: selectedRowKeys,
        [props.meta.valueExpr]: selectedRowKeys
            .map(key => treeListDataSource.find(row => row.kodp === key)[props.meta.valueExpr])
            .join(', '),
    };
    props.rowClickCallBack({ row, keyExpr });
};
</script>

<script>
export default {
    name: 'vdog-podr-lookup',
};
</script>

<style scoped></style>
